import { Link } from "react-router-dom";
import { asset } from "@/lib/api";

export function BrandMark({ builder, light = false, size = "md" }) {
  if (!builder) return null;
  const h = size === "lg" ? "h-10" : "h-8";
  return builder.logo_url ? (
    <img src={asset(builder.logo_url)} alt={builder.name} className={`${h} w-auto object-contain`} data-testid="brand-logo" />
  ) : (
    <span className={`font-serif font-semibold tracking-tight ${size === "lg" ? "text-2xl" : "text-xl"} ${light ? "text-white" : "text-bp"}`} data-testid="brand-name">
      {builder.name}
    </span>
  );
}

export function SiteHeader({ builder, right }) {
  return (
    <header className="sticky top-0 z-30 glass" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-4">
        <Link to={builder ? `/b/${builder.slug}` : "/"} data-testid="header-home-link"><BrandMark builder={builder} /></Link>
        <div className="flex items-center gap-2">{right}</div>
      </div>
    </header>
  );
}
